(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
     
  const url = new URL(window.location.href); 
  if (url.hash) { 
    document.addEventListener( 
      'DOMContentLoaded', 
      () => { 
        const card = document.getElementById(url.hash.slice(1)); 
        if (card) { 
          card.scrollIntoView({ behavior: 'instant' }); 
        } 
      }, 
      { once: true } 
    ); 
  } 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    

/* =========================================================
   CEEVEE PRODUCT FORM
   ADD TO CART LEFT + QUANTITY RIGHT
   ========================================================= */

(function () {

  function setupCeeveeProductForms() {

    const productDetails = document.querySelectorAll(
      '.product-information__details, .product-information__grid .product-details'
    );

    productDetails.forEach(function (details) {

      const forms = details.querySelectorAll(
        'form[action*="/cart/add"], form[action*="/cart/add/"]'
      );

      forms.forEach(function (form) {

        if (form.dataset.ceeveeLayoutReady === 'true') {
          return;
        }

        const submitButton = form.querySelector(
          'button[type="submit"], input[type="submit"]'
        );

        if (!submitButton) {
          return;
        }

        let quantityElement =
          form.querySelector('quantity-input') ||
          form.querySelector('quantity-selector') ||
          form.querySelector('.quantity-selector') ||
          form.querySelector('.quantity-input') ||
          form.querySelector('[class*="quantity"]');

        if (!quantityElement) {
          return;
        }

        if (!form.contains(quantityElement)) {
          return;
        }

        const actionRow = document.createElement('div');

        actionRow.className = 'ceevee-cart-quantity-row';

        const submitContainer =
          submitButton.closest(
            '.product-form__buttons, .product-form__actions, .product-form__submit'
          ) || submitButton.parentElement;

        if (!submitContainer) {
          return;
        }

        const quantityParent =
          quantityElement.closest(
            '.quantity-selector-container, .quantity-selector-wrapper, .product-form__quantity'
          ) || quantityElement.parentElement;

        if (!quantityParent) {
          return;
        }

        actionRow.appendChild(submitButton);
        actionRow.appendChild(quantityParent);

        submitContainer.insertBefore(
          actionRow,
          submitContainer.firstChild
        );

        form.classList.add('ceevee-cart-form');

        form.dataset.ceeveeLayoutReady = 'true';

      });

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      setupCeeveeProductForms
    );

  } else {

    setupCeeveeProductForms();

  }


  const observer = new MutationObserver(function () {

    setupCeeveeProductForms();

  });


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


})();


  } catch(e) { console.error(e); }
})();
})();
